document.addEventListener('DOMContentLoaded', function () {
    var videoBlocks = document.querySelectorAll('.video-block');

    var currentPlayingVideo = null;

    videoBlocks.forEach(function (videoBlock) {
        var customButton = videoBlock.querySelector('.videoControl');
        var videoElement = videoBlock.querySelector('.video-element');
        var videoElementWrapper = videoBlock.querySelector('.media-wrap');
        
        videoElement.addEventListener('loadedmetadata', function () {
            videoElement.pause();
            videoElement.removeAttribute("playing", "");
            videoElement.setAttribute("suspended", "");
        });

        videoElement.addEventListener('ended', function () {
            customButton.classList.remove('playing');
            videoElement.currentTime = 0;
            videoElement.removeAttribute("playing", "");
            videoElement.setAttribute("suspended", "");
        });

        videoElementWrapper.addEventListener('mouseenter', function (event) {
            if (currentPlayingVideo && currentPlayingVideo !== videoElement) {
                currentPlayingVideo.pause();
                currentPlayingVideo.removeAttribute("playing", "");
                currentPlayingVideo.setAttribute("suspended", "");
            }
            
            if(!videoElement.classList.contains('custom_pause')){
               videoElement.play();
              videoElement.click();
              customButton.classList.add('playing');
              currentPlayingVideo = videoElement;
            }
           
        });

        videoElement.addEventListener("play", () => {
            videoElement.setAttribute("playing", "");
            videoElement.removeAttribute("suspended", "");
            customButton.classList.add('playing');
        });

        videoElement.addEventListener("pause", () => {
            videoElement.removeAttribute("playing", "");
            videoElement.setAttribute("suspended", "");
            customButton.classList.remove('playing');
        });

        customButton.addEventListener('click', function (e) {
            if (!videoElement.paused) {
                videoElement.pause();
                videoElement.classList.add('custom_pause');
            } else {
                videoElement.play();
                currentPlayingVideo = videoElement;
            }
        });

        videoElement.addEventListener('canplaythrough', function () {
            if (videoElement.paused) {
                customButton.classList.remove('playing');
            } else {
                customButton.classList.add('playing');
                currentPlayingVideo = videoElement;
            }
        });
    });
});